import { ClientSearchSDK, SearchDocumentType } from '@wix/client-search-sdk';
import { AppSettings, createSettingsClient } from '@wix/search-settings-client';
import type { ControllerParams } from '@wix/yoshi-flow-editor';
import { Spec } from '@wix/site-search-common';

import { reportError } from './errors';

export function createGetAppSettings(
  params: ControllerParams,
): () => Promise<AppSettings> {
  const { flowAPI } = params;
  const { environment, errorMonitor, httpClient } = flowAPI;
  const settingsClient = createSettingsClient({ httpClient });

  return async () => {
    try {
      return environment.isViewer
        ? await settingsClient.getPublished()
        : await settingsClient.getSaved();
    } catch (error) {
      reportError(errorMonitor, error);
      return settingsClient.getDefault();
    }
  };
}

export function createSearchSDK(
  params: ControllerParams,
  { useRawProductDocuments = false } = {},
): ClientSearchSDK {
  const { flowAPI, controllerConfig } = params;
  const { wixCodeApi } = controllerConfig;
  const { experiments, httpClient, environment } = flowAPI;

  return new ClientSearchSDK({
    httpClient,
    siteBaseUrl: wixCodeApi.location.baseUrl,
    language: environment.language,
    timeout: 25000,
    excludeDocumentTypes: experiments.enabled(Spec.ProGallery)
      ? undefined
      : [SearchDocumentType.ProGallery],
    useRawProductDocuments,
  });
}
